import { GA4UnifiedHelper } from '@ciaopeople/cp-shatsu/Stats';
import { VideoInfoRawData } from "../../../model/video/VideoInfo.js";
import { ProgressPercentage } from '../StatsCommons.js';
import { GA4BasicCollectorConfig, GA4CPMediaProperties, GA4EventParameters, GA4MediaBasicCollector, GABoolean } from './GA4MediaBasicCollector.js';
export interface GA4VideoEngagementProperties {
    video_current_time?: number,
    video_duration?: number,
    video_url?: string,
    video_provider?: string,
    visible?: GABoolean,
    video_percent?: number,
    video_title?: string
}
export interface GA4CPVideoProperties extends GA4CPMediaProperties, GA4VideoEngagementProperties {
    video_id: string,
    video_position?: number
}

export abstract class GA4VideoBasicCollector extends GA4MediaBasicCollector<VideoInfoRawData> {

    protected ga4inst: GA4UnifiedHelper;
    protected configureCalled: boolean;


    constructor(protected readonly cfg: GA4BasicCollectorConfig,
        protected win: WindowProxy,
    ) {

        super(cfg, win);

    }

    protected abstract mangleEventData(eventName: string, inputData: GA4EventParameters, info?: VideoInfoRawData): GA4EventParameters;

    protected basicMediaParameters(info: VideoInfoRawData): GA4CPVideoProperties {
        return {
            video_id: info.id
        };
    }

    mediaProgress(info: VideoInfoRawData, progress: ProgressPercentage, props?: GA4EventParameters): Promise<void> {

        return this.trackEvent("progress", {
            ...props,
            video_progress: progress
        }, info);

    }

}